import { render, staticRenderFns } from "./person.vue?vue&type=template&id=ea3fe892&scoped=true&"
import script from "./person.vue?vue&type=script&lang=js&"
export * from "./person.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3fe892",
  null
  
)

export default component.exports